<script>
export default {
  methods: {
    getAcmfSelections() {
      const items = []
      const parentId = this.checkedOption === '0' ? 'airlineId' : 'reportTypeId'
      const childId = this.checkedOption === '0' ? 'reportTypeId' : 'airlineId'

      this.tableItems.forEach(parent => {
        if (parent.checked) {
          parent.items.forEach(child => {
            if (child.checked) {
              const tableItem = {
                [parentId]: parent.value,
                [childId]: child.value,
              }
              items.push(tableItem)
            }
          })
        }
      })

      return items
    },
    getItemsInThisGroup(groupIndex) {
      return this.tableItems.filter(itemObj => {
        return itemObj.group === groupIndex
      })
    },
  },
}
</script>
